export const ClaimStatus = {
    Created : "Created",
    AwaitingApproval : "AwaitingApproval",
    Approved : "Approved",
    Rejected : "Rejected",
    Paid : "Paid",
}as const;



export const ClaimStatusName: Record<ClaimStatus, string> = {
    [ClaimStatus.Created]: "Created",
    [ClaimStatus.AwaitingApproval]: "Awaiting Approval",
    [ClaimStatus.Approved]: "Approved",
    [ClaimStatus.Rejected]: "Rejected",
    [ClaimStatus.Paid]: "Paid",
};

export type ClaimStatus = (typeof ClaimStatus)[keyof typeof ClaimStatus];